module.exports = __webpack_public_path__ + "img/1554299312288133122.e8cd62b8.jpg";